import { render, staticRenderFns } from "./report_sales_card1.vue?vue&type=template&id=7823ccab&scoped=true"
import script from "./report_sales_card1.vue?vue&type=script&lang=js"
export * from "./report_sales_card1.vue?vue&type=script&lang=js"
import style0 from "./report_sales_card1.vue?vue&type=style&index=0&id=7823ccab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7823ccab",
  null
  
)

export default component.exports